//PRODUÇÂO
export const baseUrlLink = "https://portal.interbrasilsaude.com.br/";
export const baseUrl = "https://api-portal.interbrasilsaude.com.br/";

//DESENVOLVIMENTO
// export const baseUrlLink = "http://localhost:3000/";
// export const baseUrl = "https://dev-portal.interbrasilsaude.com.br/";
